import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './BlogAndMagazineForTaxiPage.css';

const BlogAndMagazineForTaxiPage = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get('/api/taxiblogs');
        setBlogs(response.data);
      } catch (error) {
        console.error('❌ שגיאה בקבלת המאמרים:', error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="blogs-container-BlogAndMagazineForTaxiPage">
      {blogs.map(blog => {

        return (
<div className="blog-card-BlogAndMagazineForTaxiPage" key={blog.id}>
  <div className="blog-image-wrapper-BlogAndMagazineForTaxiPage">
    <img 
      src={`/public/uploads/TaxiBlogsImg/${blog.id}.webp`}
      alt={blog.alt_text || blog.title}
      className="blog-image-BlogAndMagazineForTaxiPage"
    />
  </div>
  <div className="blog-content-BlogAndMagazineForTaxiPage">
    <h2 className="blog-title-BlogAndMagazineForTaxiPage">{blog.title}</h2>
    <p className="blog-summary-BlogAndMagazineForTaxiPage">{blog.summary}</p>
    <a href={`/blog/${blog.id}`} className="blog-link">
      קרא עוד
    </a>
  </div>
</div>

        );
      })}
    </div>
  );
};

export default BlogAndMagazineForTaxiPage;
